import { useTranslation } from "react-i18next";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { SpousalMaintenanceCalculator } from "../../../../../../../../spousal-maintenance/SpousalMaintenanceCalculator";

interface Props {
  onClose: () => void;
}

export function SpousalMaintenanceDialog({ onClose }: Props) {
  const { t } = useTranslation();
  const titleId = "spousal-maintenance-dialog-title";

  return (
    <Dialog open onClose={onClose} aria-labelledby={titleId} maxWidth="sm" fullWidth>
      <DialogTitle id={titleId}>{t("calculators.spousalMaintenance.title")}</DialogTitle>
      <DialogContent>
        <SpousalMaintenanceCalculator />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("calculators.spousalMaintenance.close")}</Button>
      </DialogActions>
    </Dialog>
  );
}
